import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


const __default__ = {
  name: "tab-panel",
};


export interface TabPanelProps {
  title: string;
  subtitle?: string;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: null,
    subtitle: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.wrap)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.header)
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.$style.title)
      }, _toDisplayString(__props.title), 3),
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.$style.subtitle)
      }, _toDisplayString(__props.subtitle), 3)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.content)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}
}

})